// NewsItem Component - Individual news item in live feed
import { Box, Typography } from '@mui/material';

interface NewsItemProps {
  news: {
    title: string;
    timestamp: string;
    isBreaking: boolean;
    subtitle?: string;
  };
  isLast: boolean;
}

export function NewsItem({ news, isLast }: NewsItemProps) {
  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 0.5, mb: 0.5 }}>
        {news?.isBreaking && (
          <Box
            sx={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              bgcolor: 'error.main',
              flexShrink: 0,
              mt: 0.75,
            }}
          />
        )}
        <Typography variant="body2" fontWeight={700} sx={{ fontSize: '0.875rem' }}>
          {news?.title || ''}
        </Typography>
      </Box>
      {news?.subtitle && (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ fontSize: '0.875rem', mb: 0.5, lineHeight: 1.5 }}
        >
          {news.subtitle}
        </Typography>
      )}
      <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
        {news?.timestamp || ''}
      </Typography>
      {!isLast && <Box sx={{ mt: 2.5, borderBottom: '1px solid', borderColor: 'divider' }} />}
    </Box>
  );
}

export default NewsItem;
